import { useState } from 'react'
import { Modal } from 'components'
import toast from 'react-hot-toast'
import { lang } from 'config'
import { useAuth } from "contexts/auth-context"
import { executeAPI } from "repositories/db-repository"
import { useSWRConfig } from "swr"
import { useNavigate } from "react-router-dom"

const Content = ({ data, success }) => {
    const { user } = useAuth()
    const [errors, setErrors] = useState({})
    const { cache } = useSWRConfig()
    const navigate = useNavigate()

    const receiveSales = (data) => {

        const onSuccess = (result, message) => {
            cache.clear()
            navigate({ pathname: '/purchase' })
            toast.success("Sales info sudah diterima!", {
                id: "submit"
            })
        }

        const onError = (message) => {
            toast.error("onError: " + message, {
                id: "submit"
            })
        }

        executeAPI(`${process.env.REACT_APP_REMAX_PS_API_URL}`, "receive_sales_transaction", 
        {
            id: data?.sales_transaction?.id,
            exclude_header: 1,
            outlet_group_id: data?.sales_transaction?.outlet_group_id,
            outlet_group_name: data?.sales_transaction?.outlet_group_name,
            public_id: data?.sales_transaction?.public_id,
            user_id: user?.id,
            user_name: user?.name,
            outlet_id: data?.sales_transaction?.outlet_id,
            outlet_name: data?.sales_transaction?.outlet_name,
            latest_flow_detail_id: data?.sales_transaction?.latest_flow_detail_id,
            arr_purchase_header: JSON.stringify(data?.sales_header),
            arr_purchase_item: JSON.stringify(data?.sales_item),
            created_by: user?.name
        },
        onSuccess, onError)
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        
        const onSuccess = (result, message) => {
            cache.clear()
            if (result?.sales_transaction?.latest_flow_detail_id !== "SALES_REQUEST_DRAFT") {
               receiveSales(result) 
            } else {
                cache.clear()
                navigate({ pathname: '/purchase' })
                toast.error("Belum ada status terbaru!", {
                    id: "submit"
                })
            }
        }

        const onError = (message) => {
            cache.clear()
            navigate({ pathname: '/purchase' })
            toast.error(message, {
                id: "submit"
            })
        }

        if (data.id) {
            toast.loading("Loading", {
                id: "submit"
            })
    
            executeAPI(`${process.env.REACT_APP_REMAX_SS_API_URL}`, "sales_transaction_all", 
            {
                id: data?.id,
            },
            onSuccess, onError)
        } else {
            setErrors({
                
            })
        }
    }

    return (
        <form onSubmit={handleSubmit} className="mt-8 space-y-8">
            {lang.are_you_sure_you_want_to_refresh} <span className="inline-flex px-3 py-1 text-sm font-medium rounded-xl bg-neutral-200 text-neutral-600">{data?.purchase_number}</span> ?
            <div className="text-xs">
                <button type="submit" className="items-center px-6 py-3 text-white transition bg-neutral-800 rounded-xl active:hover:scale-90">
                    <span>{lang.yes}</span>
                </button>
            </div>
        </form>
    )
}

const Refresh = ({ data, onSuccess }) => {
    const [isOpen, setIsOpen] = useState(false)

    const openModal = () => setIsOpen(true)
    const closeModal = () => setIsOpen(false)

    const handleSuccess = () => {
        closeModal()
        onSuccess()
    }

    return (
        <>
            <button disabled={false} onClick={ data.status !== "SALES_ORDER_CLOSED" && data.status !== "SALES_ORDER_COMPLETED" && data.status !== "SALES_ORDER_BILL_PO_CREATED" && (data.status == "PURCHASE_ORDER_SENT" || data.status.substring(0, 5) == "SALES") ? openModal : () => {}} class={`${ !(data.status !== "SALES_ORDER_CLOSED" && data.status !== "SALES_ORDER_COMPLETED" && data.status !== "SALES_ORDER_BILL_PO_CREATED" && (data.status == "PURCHASE_ORDER_SENT" || data.status.substring(0, 5) == "SALES")) ? 'opacity-50 bg-red-900' : 'bg-red-800'} inline-flex items-center p-1 text-white transition rounded-full active:hover:scale-90`}>
                <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" width={24} height={24} viewBox="0 0 24 24" strokeWidth={1} stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                    <path d="M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4" />
                    <path d="M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4" />
                </svg>
            </button>
            <Modal isOpen={isOpen} onClose={closeModal} title={`${lang.refresh} ${lang.status}`} content={<Content data={data} success={handleSuccess} />} />
        </>
    )
}

export default Refresh